import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import RemoveModelModal from 'src/components/global-settings/RemoveModelModal'
import { removeVehicleModel, getVehicleCreateOptions } from 'src/state/actions/vehicles'
import { getOrganization, getVehicleModel } from 'src/state/selectors'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    id: ownProps.match.params.id,
    setting: getVehicleModel(ownProps.match.params.id, state)
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    removeVehicleModel: (id: string) => {
      return new Promise((approve, reject) => {
        dispatch(removeVehicleModel(id)).then(() => {
          dispatch(getVehicleCreateOptions()).then(() => {
            approve()
          })
        })
      })
    },
    getVehicleCreateOptions: () => dispatch(getVehicleCreateOptions())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemoveModelModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/RemoveModelModal.ts